import * as ACTION from './constants';
import * as apiService from '../../services/apiServices';

// ACTION CREATORS
export const companyBase = () => ({ type: ACTION.COMPANY_BASE });
export const isLibraryLoading = () => ({ type: ACTION.LIBRARY_LOADING });
export const libraryLoaded = (companies = []) => ({ type: ACTION.LIBRARY_LOADED, companies });

export const usersLoading = () => ({ type: ACTION.USERS_LOADING });
export const usersLoadingError = (id, error) => ({ type: ACTION.USERS_LOADING_ERROR, id, error });
export const usersLoaded = (id, users) => ({ type: ACTION.USERS_LOADED, id, users });

export const cohortsLoading = () => ({ type: ACTION.COHORTS_LOADING });
export const cohortsLoadingError = (id, error) => ({ type: ACTION.COHORTS_LOADING_ERROR, id, error });
export const cohortsLoaded = (id, cohorts) => ({ type: ACTION.COHORTS_LOADED, id, cohorts });

export const creatingCohort = () => ({ type: ACTION.CREATING_COHORT });
export const cohortCreated = (companyId, cohort) => ({ type: ACTION.COHORT_CREATED, companyId, cohort });

export const cohortUpdating = () => ({ type: ACTION.COHORT_UPDATING });
export const cohortUpdated = (id, data) => ({ type: ACTION.COHORT_UPDATED, id, data });
export const setCohortForm = (data) => ({ type: ACTION.SET_COHORT_FORM, data });

export const trainersLoading = () => ({ type: ACTION.TRAINERS_LOADING });
export const trainersLoaded = () => ({ type: ACTION.TRAINERS_LOADED });

export const wellnessProgramsLoading = () => ({ type: ACTION.WELLNESS_PROGRAMS_LOADING });
export const wellnessProgramsLoaded = () => ({ type: ACTION.WELLNESS_PROGRAMS_LOADED });

export const cohortMemberLoading = () => ({ type: ACTION.COHORT_MEMBER_LOADING });
export const cohortMemberLoaded = () => ({ type: ACTION.COHORT_MEMBER_LOADED });

export const getCompanies = (params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(isLibraryLoading());
    apiService.getCompanies(params)
    .then(response => {
      dispatch(libraryLoaded(response));
      resolve(response);
    })
    .catch(error => {
      dispatch(companyBase()); reject(error);
    });
  });
}

export const getCompanyUsers = (params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(usersLoading());
    apiService.getCompanyUsers(params.id)
    .then(response => {
      dispatch(usersLoaded(params.id, response));
      resolve(response);
    })
    .catch(error => {
      dispatch(usersLoadingError(params.id, error));
      reject(error);
    });
  });
}

export const getCompanyCohorts = (params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(cohortsLoading());
    apiService.getCompanyCohorts(params.id)
    .then(response => {
      response.forEach((item, index) => {
        item.program = item.program === null ? '' : item.program;
      });
      dispatch(cohortsLoaded(params.id, response));
      resolve(response);
    })
    .catch(error => {
      dispatch(cohortsLoadingError(params.id, error));
      reject(error);
    });
  });
}

export const createCompanyCohort = (params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(creatingCohort());
    apiService.createCompanyCohort(params)
    .then(response => {
      dispatch(cohortCreated(response.company, response));
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  });
}

export const updateCompanyCohort = (id, params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(cohortUpdating());
    apiService.updateCompanyCohort(id, params)
    .then(response => {
      dispatch(cohortUpdated(id, response));
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  });
}

export const getDigitalCoachingTrainers = () => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(trainersLoading());
    apiService.getDigitalCoachingTrainers('thestjames')
    .then(response => {
      dispatch(trainersLoaded());
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  });
}

export const getWellnessPrograms = () => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(wellnessProgramsLoading());
    apiService.getWellnessPrograms()
    .then(response => {
      dispatch(wellnessProgramsLoaded());
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  });
}

export const createCohortProgram = (params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(cohortUpdating());
    apiService.createCohortProgram(params)
    .then(response => {
      dispatch(cohortUpdated(params.id, response));
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  });
}

export const updateCohortProgram = (id, params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(cohortUpdating());
    apiService.updateCohortProgram(id, params)
    .then(response => {
      dispatch(cohortUpdated(id, response));
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  });
}

export const addMemberToCohort = (id, params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(cohortMemberLoading());
    apiService.addMemberToCohort(id, params)
    .then(response => {
      dispatch(cohortMemberLoaded());
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  });
}

export const removeMemberFromCohort = (id, memberId, params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(cohortMemberLoading());
    apiService.removeMemberFromCohort(id, memberId, params)
    .then(response => {
      dispatch(cohortMemberLoaded());
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  });
}
